import text from './stateText';
import { eventsService } from '@/services';

let store;

export default function (providers) {
  const { $api } = providers;

  store = store || {
    namespaced: true,

    state: () => ({
      slides: [],
      events: [],
      text,
    }),

    mutations: {
      setEvents(state, payload) {
        state.events = payload;
      },

      setSlides(state, payload) {
        state.slides = payload;
      },
    },

    actions: {
      init({ dispatch, commit }, { events, slides }) {
        const setCrumbs = function () {
          commit('setCrumbs', [], { root: true });
        };
        return Promise.all([
          dispatch('getEvents', events),
          dispatch('getSlides', slides),
        ])
          .then(setCrumbs)
          .catch(setCrumbs);
      },

      async getEvents({ commit, rootState }, params) {
        if (params.municipality === '') {
          delete params.municipality;
        }

        const f = (data, count) => {
          commit('setEvents', data);
        };

        try {
          const { filtered, data } = await eventsService($api).getEvents(
            params,
          );

          f(data, filtered ? filtered : data.length);
        } catch (e) {
          f([], 0);
        }

        return Promise.resolve();
      },

      getSlides({ commit }, count) {
        let params = {};
        if (count) {
          params.params = { limit: count };
        }
        return $api
          .get('index/slides', params)
          .then((res) => {
            commit('setSlides', res.data.data);
          })
          .catch((err) => {
            commit('setSlides', []);
          });
      },
    },
  };

  return store;
}



// WEBPACK FOOTER //
// ./src/pages/home/store.js